import React, { useEffect, useLayoutEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Typography,
  Tabs,
  Tab,
  Popper,
  ClickAwayListener,
  Paper,
  Chip,
  TextField,
  InputAdornment,
  Modal,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import SearchBar2 from "../../components/SearchBar2";
import Autocomplete from "@mui/material/Autocomplete";
import { isValidInput } from "../../utils/validation";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  useGetAllQuoteMutation,
  useRevertQuoteMutation,
} from "../../services/quote";
import { errorToast, successToast } from "../../helpers";
import {
  useGetAllQuoteCountMutation,
  useLazyProductByVendorQuery,
  useProductListMutation,
} from "../../services/products";
import { generateResponsiveStyle } from "../../utils/modalStyle";
import Loader from "../../helpers/constants/Loader";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageQuotes = () => {
  const { state } = useLocation();
  const t = useTranslation();
  const style = generateResponsiveStyle();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [revertQuote] = useRevertQuoteMutation();
  const [getCount] = useGetAllQuoteCountMutation();
  const navigate = useNavigate();
  const [allQuotes] = useGetAllQuoteMutation();
  const [getProductsList] = useLazyProductByVendorQuery();
  const { pathname } = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<number>(10);
  const [open1, setOpen1] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [value, setValue] = React.useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [quoteData, setQuoteData] = useState<any>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [productsData, setProductsData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState("");
  const [time, setTime] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [selectedProduct, setSelectedProduct] = useState<any>("");
  const [isProduct, setIsProduct] = useState(false);
  const [count, setCount] = useState<any>("");

  const [selectedId, setSelectedId] = useState("");
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
      if (
        selectedRange.from !== undefined &&
        selectedRange.to !== undefined &&
        selectedRange.from !== selectedRange.to
      ) {
        setOpen1(false);
      }
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useLayoutEffect(() => {
    if (state) {
      setValue(state?.value);
    }
  }, []);

  const getAllQuotes = async () => {
    setLoading(true);
    let body = {
      order_status: value === 0 ? 1 : value === 1 ? 4 : value === 2 ? 3 : 2,
      ...(range?.from
        ? { start_date: moment(range?.from).startOf("day") }
        : {}),
      ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
      search: debouncedSearchTerm,
    };

    try {
      const response = await allQuotes(body).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setQuoteData(response?.data?.response_object || []);
        setPrice("");
        setTime("");
        setSelectedCondition("");
        setSelectedPayment("");
        setSelectedProduct("");
      } else {
        setLoading(false);
        setQuoteData([]);
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || "");
    }
  };

  const getAllProducts = async () => {
    try {
      const response = await getProductsList({}).unwrap();
      if (response.status === 200) {
        setProductsData(response?.data);
      } else {
        setProductsData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getQuoteCount = async () => {
    const body = {
      search: debouncedSearchTerm,
      ...(range?.from
        ? { start_date: moment(range?.from).startOf("day") }
        : {}),
      ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
    };
    try {
      const res = await getCount(body).unwrap();
      if (res?.status === 200) {
        setCount(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const handleRequestStatus = async (id: any) => {
    // Create the body object based on the status

    const body = {
      price_per_unit: Number(price),
      offer_valid_time: Number(time),
      delivery_condItions: Number(selectedCondition),
      payment_method: Number(selectedPayment),
      product: Number(selectedProduct),
    };

    try {
      const response = await revertQuote({
        body,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        successToast("Quote sent successfully");
        setModalOpen(false);
        getAllQuotes();
        setIsProduct(false);
      } else {
        errorToast("Please try again");
      }
    } catch {
      errorToast("Something went wrong");
    }
  };

  useEffect(() => {
    getAllQuotes();
    getQuoteCount();
  }, [value, range?.from, range?.to, debouncedSearchTerm]);

  useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageQuotes}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header" marginBottom={"20px"}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <div className="control_group" style={{ width: 250 }}>
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder={t.main.selectDateRange}
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label={t.main.lastWeek}
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label={t.main.lastMonth}
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label={t.main.lastYear}
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}
                        month={month}
                        onMonthChange={handleMonthChange}
                        // styles={{
                        //   months: { display: "flex", gap: "16px" },
                        //   month: { margin: 0 },
                        // }}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>

            <Box className="cards_header_right">
              {/* <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-vendors/add")}
                >
                  <AddIcon /> Add Vendor
                </Button> */}
              {/* <Button
                className="btn btn_primary"
                // onClick={handleExportCsv}
                disabled={quoteData?.length === 0 ? true : false}
              >
                <FileDownloadIcon /> Export CSV
              </Button> */}
            </Box>
          </Box>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`${t.main.pending}${count?.PENDING ? ` (${count?.PENDING})` : ""}`}
                {...a11yProps(0)}
              />
              <Tab
                label={`${t.main.inProgress}${count?.ON_GOING ? ` (${count?.ON_GOING})` : ""}`}
                {...a11yProps(1)}
              />
              <Tab
                label={`${t.main.approved}${count?.ACCEPT ? ` (${count?.ACCEPT})` : ""}`}
                {...a11yProps(2)}
              />
              <Tab
                label={`${t.main.rejected}${count?.REJECT ? ` (${count?.REJECT})` : ""}`}
                {...a11yProps(3)}
              />
            </Tabs>

            <TableContainer className="table_container">
              <Box className="heading"></Box>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell>{t.main.customerName}</TableCell>
                    <TableCell>{t.main.email}</TableCell>
                    <TableCell>{t.main.category}</TableCell>
                    <TableCell>{t.main.subCategory}</TableCell>
                    <TableCell>{t.main.productQuantity}</TableCell>
                    <TableCell>{t.main.price}</TableCell>
                    <TableCell>{t.main.specificReq}</TableCell>
                    <TableCell>{t.main.chat}</TableCell>
                    <TableCell>{t.main.quoteStatus}</TableCell>
                    {value === 0 ? (
                      <TableCell>{t.main.quoteStatus}</TableCell>
                    ) : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quoteData?.length == 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        {t.error.noData}
                      </TableCell>
                    </TableRow>
                  ) : (
                    quoteData?.map((row: any, i: any) => (
                      <TableRow key={row.name}>
                        <TableCell align="center">
                          {(page - 1) * 10 + i + 1}
                        </TableCell>

                        <TableCell>{row?.consumer_name || "-"}</TableCell>
                        <TableCell>{row?.consumer_email || "-"}</TableCell>
                        <TableCell>{row?.category || "-"}</TableCell>
                        <TableCell>{row?.sub_category || "-"}</TableCell>
                        <TableCell>{row?.quantity || "-"}</TableCell>
                        <TableCell>{`${currency === "USD" ? "USD" : "AED"} ${row?.price || "0"}`}</TableCell>
                        <TableCell
                          style={{
                            flexWrap: "wrap",
                            minWidth: 300,
                            textWrap: "wrap",
                          }}
                        >
                          {row?.specific_requirement || "-"}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate("/quote-chat", {
                                state: {
                                  sessionId: row?.session,
                                  value: value,
                                },
                              })
                            }
                          >
                            <ChatBubbleIcon sx={{ color: "#2B604C" }} />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={
                              value === 0
                                ? t.main.quoteNotSubmitted
                                : t.main.quotedSubmitted
                            }
                            sx={{ backgroundColor: "black", color: "white" }}
                          />
                        </TableCell>
                        {value === 0 ? (
                          <TableCell>
                            <Chip
                              label={t.main.sendQuotation}
                              variant="outlined"
                              onClick={() => {
                                setSelectedId(row?.id);
                                setModalOpen(true);
                                setSelectedProduct(row?.product_id);
                                setPrice(row?.price);
                                if (row?.product_id) {
                                  setIsProduct(true);
                                }
                              }}
                              sx={{ borderColor: "#2B604C" }}
                            />
                          </TableCell>
                        ) : null}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Card>
      </div>
      <Modal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setIsProduct(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="modal_title">
            <Typography id="modal-modal-title" component="h2">
              {t.main.sendQuote}
            </Typography>
            <CloseIcon
              className="cross_icn_logout"
              onClick={() => {
                setIsProduct(false);
                setModalOpen(false);
              }}
            />
          </div>

          <div className="modal_body">
            <div className="control_group">
              <TextField
                className="text_field"
                hiddenLabel
                placeholder={t.main.pricePerUnit}
                fullWidth
                inputProps={{ maxLength: 10 }}
                type="text"
                variant="outlined"
                value={price}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value === " " || value === ".") return;

                  // Regex to allow only numbers with up to two decimal places
                  if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setPrice(value);
                  }
                }}
              />
            </div>
            <div className="control_group" style={{ marginTop: 20 }}>
              <TextField
                className="text_field"
                hiddenLabel
                placeholder={t.main.timeFrame}
                inputProps={{ maxLength: 3 }}
                fullWidth
                type="text"
                variant="outlined"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              />
            </div>
            <div className="control_group" style={{ marginTop: 20 }}>
              <Select
                className="select_div"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedCondition}
                onChange={(e) => setSelectedCondition(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  {t.main.deliveryConditions}
                </MenuItem>

                <MenuItem value={"1"}>{t.main.shippingCharge}</MenuItem>
                <MenuItem value={"2"}>{t.main.freeDelivery}</MenuItem>
              </Select>
            </div>
            <div className="control_group" style={{ marginTop: 20 }}>
              <Select
                className="select_div"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedPayment}
                onChange={(e) => setSelectedPayment(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  {t.main.payment}
                </MenuItem>

                <MenuItem value={"1"}>{t.main.refundable}</MenuItem>
                <MenuItem value={"2"}>{t.main.nonRefundable}</MenuItem>
              </Select>
            </div>
            {/* <div className="control_group" style={{ marginTop: 20 }}>
              <Select
                className="select_div"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedProduct}
                onChange={(e: any) => setSelectedProduct(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Product
                </MenuItem>
                {productsData?.map((product: any) => (
                  <MenuItem key={product?.id} value={product?.id}>
                    {product?.product_name}
                  </MenuItem>
                ))}
              </Select>
            </div> */}
            <FormControl sx={{ width: "100%", marginTop: 3 }}>
              <Autocomplete
                // multiple
                options={productsData}
                getOptionLabel={(option) =>
                  option?.product_name_en || "No Name"
                }
                disabled={isProduct}
                value={
                  productsData?.find(
                    (item: any) => item?.id === selectedProduct
                  ) || null
                }
                onChange={(event, newValue) => {
                  setSelectedProduct(newValue?.id || "");
                }}
                ListboxProps={{
                  style: { maxHeight: "150px" }, // Adjust dropdown height here
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={t.main.selectProduct}
                    // error={
                    //   formik.touched.receiverId &&
                    //   Boolean(formik.errors.receiverId)
                    // }
                    // helperText={
                    //   formik.touched.receiverId && formik.errors.receiverId
                    //     ? formik.errors.receiverId.toString()
                    //     : ""
                    // }
                  />
                )}
              />
            </FormControl>
            <div className="form_btn">
              <Button
                disabled={
                  price === "" ||
                  time === "" ||
                  selectedCondition === "" ||
                  selectedPayment === "" ||
                  selectedProduct === ""
                }
                className="btn btn_primary"
                onClick={() => {
                  handleRequestStatus(selectedId);
                }}
              >
                {t.main.update}
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => {
                  setIsProduct(false);
                  setModalOpen(false);
                }}
              >
                {t.main.cancel}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* <ReasonModal
        open={openReject}
        setOpen={setOpenReject}
        handleDelete={handleReject}
        reason={rejectionReason}
        setReason={setRejectionReason}
      /> */}
    </div>
  );
};

export default ManageQuotes;
